import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div>
          <h3>Address</h3>

          <p>
            Pune, Maharashtra (INDIA), 411037.
          </p>
        </div>

        <div>
          <h3>Quick Links</h3>

          <ul>
            <li>
              <a href="/about">
                Company Profile
              </a>
            </li>

            <li>
              <a href="/products">
                Our Products
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3>Contact</h3>

          <p>+91-7507002346</p>

          <p>info@krisulaglobexim.com</p>
        </div>
      </div>

      <div className="copyright">
        © 2026 Krisula GlobExim Pvt. Ltd.
      </div>
    </footer>
  );
};

export default Footer;